import { InjectedStyledComponent } from '../InjectedStyledComponent';

export default InjectedStyledComponent('label', 'shared', ['label']);